<template>
  <div>
    <div class="coupon-item">
      <div class="flex-1">
        <div class="code">
          <p class="item-value">کد تخفیف:</p>
          {{ couponItem.code }}
        </div>
        <div class="code">
          <p class="item-value">مقدار:</p>
          {{ couponItem.value.toString().numberFormat() }}
          {{ couponItem.percentage_based ? "درصد" : "تومان" }}
        </div>
        <div class="code">
          <p class="item-value">تاریخ انقضا:</p>
          {{ couponItem.human_readable_expires_at }}
        </div>
        <div class="code">
          <p class="item-value">تعداد فروش:</p>
          0
        </div>
        <div class="code">
          <p class="item-value">مجموع فروش:</p>
          0 ریال
        </div>
        <div class="code">
          <p class="item-value">تعداد دفعات استفاده برای کاربران:</p>
          {{ couponItem.unlimited ? "نامحدود" : "یکبار مصرف" }}
        </div>
      </div>
      <div class="flex">
        <vs-button
          @click="editCouponPopup = true"
          class="flex-1 mr-1"
          color="primary"
          type="filled"
          size="small"
          icon-pack="feather"
          icon="icon-edit"
        />
        <vs-button
          @click="deleteCoupon(couponItem.id)"
          class="flex-1 ml-1"
          color="danger"
          type="filled"
          size="small"
          icon-pack="feather"
          icon="icon-trash-2"
        />
      </div>
    </div>

    <vs-popup title="کد تخفیف" :active.sync="editCouponPopup">
      <new-coupon :coupon="item" @couponEdited="couponEdited" />
    </vs-popup>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import providerApiService from "../../services/api/ProviderApiService";
  import NewCoupon from "./NewCoupon.vue";

  export default {
    components: { NewCoupon },
    name: "CouponItem.vue",
    computed: {
      ...mapGetters({
        currentProvider: "profile/currentProvider",
      }),
    },
    data() {
      return {
        couponItem: { ...this.item },
        editCouponPopup: false,
      };
    },
    props: {
      item: {
        required: true,
        type: Object,
      },
    },
    watch: {
      item(newValue) {
        this.couponItem = newValue;
      },
    },
    methods: {
      couponEdited(coupon) {
        this.couponItem = coupon;
        this.editCouponPopup = false;
      },
      deleteCoupon(couponId) {
        this.$vs.loading();
        providerApiService
          .deleteCoupon(this.currentProvider.id, couponId)
          .then(() => {
            this.$vs.notify({
              text: "کد تخفیف با موفقیت حذف شد.",
              color: "success",
              position: "bottom-center",
            });
            this.$emit("couponDeleted", this.couponItem);
          })
          .finally(() => this.$vs.loading.close());
      },
    },
  };
</script>

<style lang="scss">
  .coupon-item {
    background-color: #ffffff;
    min-height: 100px;
    margin: 0 5px;
    padding: 5px 10px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 1px rgba(var(--vs-primary), 0.15);
    display: flex;
    align-items: center;

    .code {
      margin: 5px 0;
      display: flex;
      align-items: center;
      font-size: 1rem;
      color: #232323;
      font-weight: 500;
    }

    .item-value {
      color: gray;
      font-weight: 400;
      font-size: 0.9rem;
      margin-right: 4px;
      margin-top: 1px;
    }
  }
</style>
